module.exports = __webpack_public_path__ + "static/media/support-tickets.703bf36b.png";